/**
 * StrategyTabs - Reusable challenge type tab selector
 */

const StrategyTabs = ({ strategies, selectedStrategy, onStrategyChange, className = '' }) => {
  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {strategies.map((strategy) => (
        <button
          key={strategy.type}
          onClick={() => onStrategyChange(strategy.type)}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-2 ${
            selectedStrategy === strategy.type
              ? 'bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300'
              : 'bg-gray-50 dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700'
          }`}
        >
          <span>{strategy.icon}</span>
          <span>{strategy.name}</span>
        </button>
      ))}
    </div>
  )
}

export default StrategyTabs
